// @flow
import is from 'mz-utils/is'
import { withValues, type Message } from 'mz-intl'
import messages from '../messages.intl'

// Types
import type { StripeSource } from '../stripe'

export type StripeErrorType = {
  code: string,
  message: string,
}

export const ERROR_CODES = {
  init_error: 'init_error',
  card_declined: 'card_declined',
  incomplete_number: 'incomplete_number',
  incomplete_expiry: 'incomplete_expiry',
  incomplete_cvc: 'incomplete_cvc',
  threed_secure_declined: 'threed_secure_declined',
  threed_secure_canceled: 'threed_secure_canceled',
  threed_secure_not_supported: 'threed_secure_not_supported',
  not_stripe_api_key: 'not_stripe_api_key',
  missing_card_or_customer: 'missing_card_or_customer',
  stripe_not_initialized: 'stripe_not_initialized',
  payment_method_not_available: 'payment_method_not_available',
  processing_error: 'processing_error',
}

/**
 * Wrapper for stripe errors.
 * @param {string} code API Error code
 */
export class StripeError extends Error {
  code: string

  message: string

  i18n: Message

  source: ?StripeSource

  constructor(code: ?string, source?: ?StripeSource, rawErrorMessage?: string) {
    super()
    const normCode =
      code && is.string(code) ? code.toUpperCase() : 'UNKNOWN_ERROR'
    const normErrorMessage = rawErrorMessage || 'unknown error'
    const isKnownError = !!messages[(normCode: any)]

    const intlMessage =
      messages[(normCode: any)] ||
      withValues(messages.UNKNOWN_STRIPE_ERROR, {
        code: normCode,
        message: normErrorMessage,
      })

    const stringMessage = isKnownError
      ? intlMessage.defaultMessage
      : `${normErrorMessage} (${normCode})`

    this.code = normCode
    this.message = stringMessage
    this.i18n = intlMessage
    this.source = source
  }
}

export default StripeError
